import {Fragment, useEffect, useState} from "react";
import {
    Box,
    Button, Collapse,
    Container, IconButton, Skeleton, Stack, styled,
    Table,
    TableBody, tableBodyClasses,
    TableCell, tableCellClasses,
    TableContainer,
    TableHead, tableHeadClasses,
    TableRow,
    Typography
} from "@mui/material";
import { Helmet } from "react-helmet";
import { AccessTime, CalendarMonthRounded, CancelOutlined, DoneRounded, WorkspacePremiumRounded } from "@mui/icons-material";
import { getAllActivePacks, pay } from "../../../lib/services/drive";
import Toasty from "../../../theme/components/Toasty";
import { LoadingButton } from "../../../theme/components/LoadingButton";
import { farsiDate, farsiHour, getTimeDifference } from "../../../lib/commonFunctions/dateConvertor";
import { useUser } from "../../../lib/hooks";
import { convertSize } from "../../../lib/commonFunctions/convertSize";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';


function Row(props) {
    const { row } = props;
    const [open, setOpen] = useState(false);

    return (
        <Fragment>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell>
                    <Typography mt={.5} fontSize={{ xs: ".85rem", lg: ".925rem" }} fontWeight={600}>{row.name}</Typography>
                </TableCell>
                {/*<TableCell>{row.description}</TableCell>*/}
                <TableCell>{row.getSize(row.driveSize)?.toLocaleString('fa-IR')}</TableCell>
                <TableCell>{row.price ? `${row.price?.toLocaleString('fa-IR')} ریال` : "رایگان"}</TableCell>
                <TableCell><YesOrNo boolean={row.allowMobileSharing} /></TableCell>
                <TableCell>{row.getSize(row.fileUploadSize)?.toLocaleString('fa-IR')}</TableCell>
                <TableCell>{row.period?.toLocaleString('fa-IR')} روزه</TableCell>
                <TableCell>
                    {row.userActivePack?.id === row.id
                        ?
                        <Button
                            disabled variant="contained"
                            fullWidth disableElevation
                            startIcon={<DoneRounded />}
                            sx={{ py: 1.5, backgroundColor: theme => theme.palette.success.main + "!important", color: "#fff!important" }}>فعال شده</Button>
                        :
                        <LoadingButton
                            loading={row.pending === row.id}
                            onClick={() => row.handleOnPurchaseClick(row.id)}
                            variant="contained"
                            fullWidth disableElevation sx={{ py: 1.5 }}>خرید</LoadingButton>
                    }
                </TableCell>
            </TableRow>

            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8} sx={{background: '#eeeeee', boxShadow: '0px 0px 2rem 0rem rgb(193 193 193 / 22%) inset'}}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1 }}>
                            <Typography variant="h6" gutterBottom component="div">توضیحات</Typography>
                            <Typography component="p">{row.description}</Typography>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </Fragment>
    );
}

Row.propTypes = {
    row: PropTypes.shape({
        // description: PropTypes.string.isRequired,
        driveSize: PropTypes.number.isRequired,
        price: PropTypes.string.isRequired,
        allowMobileSharing: PropTypes.string.isRequired,
        fileUploadSize: PropTypes.number.isRequired,
        period: PropTypes.string.isRequired,
    }).isRequired,
};


export default function Plans() {

    const user = useUser();
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pending, setPending] = useState(0);
    const userActivePack = user?.userActivePack;

    const handleOnPurchaseClick = async (id) => {
        setPending(id);
        try {
            const { data } = await pay('package', { packageId: id });
            if (data?.isSuccess) {
                if (data.value?.gatewayUrl) window.location.href = data.value.gatewayUrl;
            } else {
                if (data && data.errors?.length) {
                    setPending(false);
                    data.errors.map(i => Toasty.error(i));
                }
            }
        } catch (err) {
            console.log(err);
            Toasty.error('خطایی غیر منتظره رخ داد')
        }
        setPending(false);
    }
    const getSize = (number) => {
        return convertSize((number * 1024 * 1024), { farsi: true, fixed: true });
    }

    async function getPlans() {
        try {
            const { data } = await getAllActivePacks();
            if (data?.isSuccess) {
                setPlans(data.value);
            } else {
                if (data && data.errors?.length) {
                    data.errors.map(i => Toasty.error(i));
                }
            }
        } catch (err) {
            console.log(err);
            Toasty.error('خطایی پیش آمد');
        }
        setLoading(false);
    }
    useEffect(() => {
        getPlans();
    }, []);

    return (
        <>
            <Helmet>
                <title>درایو میلفا - بسته ها</title>
            </Helmet>
            <Container sx={{ mt: 3 }}>
                <Typography fontSize={{ xs: "1.1rem" }} fontWeight={600}>بسته ها</Typography>
                <Box mt={2} display="flex">
                    <Stack width={1} direction={{lg: "row"}} alignItems="center" flexWrap="wrap" rowGap={2} columnGap={2}>
                        <Box sx={{ p: 2, width: {xs: "100%", lg: "auto"}, display: "flex", alignItems: "center", background: '#FFCCBC', color: "#b23f00", borderRadius: 1 }}>
                            <WorkspacePremiumRounded fontSize="small" />
                            <Typography ml={1} fontSize=".85rem" fontWeight={500}>پلن فعلی: {userActivePack?.name ? userActivePack.name : "نامشخص"}</Typography>
                        </Box>
                        <Box sx={{ p: 2, width: {xs: "100%", lg: "auto"}, display: "flex", alignItems: "center", background: '#C5E1A5', color: "#1B5E20", borderRadius: 1 }}>
                            <CalendarMonthRounded fontSize="small" />
                            <Typography ml={1} fontSize=".85rem" fontWeight={500}>تاریخ خرید: {`${farsiHour(userActivePack?.orderDate)} - ${farsiDate(userActivePack?.orderDate)}`}</Typography>
                        </Box>
                        <Box sx={{ p: 2, width: {xs: "100%", lg: "auto"}, display: "flex", alignItems: "center", background: '#81D4FA', color: "#014173", borderRadius: 1 }}>
                            <AccessTime fontSize="small" />
                            <Typography ml={1} fontSize=".85rem" fontWeight={500}>زمان باقی مانده: {getTimeDifference(userActivePack?.expireDate, true)}</Typography>
                        </Box>
                    </Stack>
                </Box>



                <TableContainer component={Paper} sx={{ mt: 3 }}>
                    <Table aria-label="collapsible table">
                        <TableHead sx={{background: '#eeeeee'}}>
                            <TableRow>
                                <TableCell />
                                <TableCell>پلان ها</TableCell>
                                {/*<TableCell>توضیحات</TableCell>*/}
                                <TableCell>حجم</TableCell>
                                <TableCell>قیمت</TableCell>
                                <TableCell>اشتراک موبایل</TableCell>
                                <TableCell>حداکثر حجم آپلود</TableCell>
                                <TableCell>دوره</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        {!loading
                            ?
                        <TableBody>
                            {plans.map((row) => (
                                <Row key={row.name} row={Object.assign(row, {
                                    getSize: (n) => getSize(n),
                                    handleOnPurchaseClick: (id) => handleOnPurchaseClick(id),
                                    userActivePack: userActivePack,
                                    pending: pending,
                                })} />
                            ))}
                        </TableBody>
                        :
                        <LoadingSkeleton />
                        }
                    </Table>
                </TableContainer>
            </Container>
        </>
    )
}

const StyledTable = styled(Table)(({ theme }) => ({
    [`& .${tableCellClasses.root}`]: { whiteSpace: "noWrap", textAlign: "center" },
    [`& .${tableHeadClasses.root} .${tableCellClasses.root}`]: {
        background: theme.palette.primary.light,
        color: "initial",
    },
    [`& .${tableHeadClasses.root} .${tableCellClasses.root}:first-of-type`]: {
        borderRadius: "5px 0 0 0"
    },
    [`& .${tableHeadClasses.root} .${tableCellClasses.root}:last-of-type`]: {
        borderRadius: "0 5px 0 0"
    },
    [`& .${tableBodyClasses.root}`]: {
        background: theme.palette.grey.main,
    }
}));
const YesOrNo = ({ boolean }) => {
    switch (boolean) {
        case true: return <DoneRounded color="success" fontSize="small" />
        case false: return <CancelOutlined color="error" fontSize="small" />;
        default: return <CancelOutlined color="error" fontSize="small" />;
    }
}
const LoadingSkeleton = () => {
    return (
        <TableBody>
            {Array.from([...new Array(4)]).map((_, ind) => (
                <TableRow key={ind}>
                    <TableCell>
                        <Skeleton width="100%" />
                    </TableCell>
                    <TableCell><Skeleton width="100%" /></TableCell>
                    <TableCell><Skeleton width="100%" /></TableCell>
                    <TableCell><Skeleton width="100%" /></TableCell>
                    <TableCell><Skeleton width="100%" /></TableCell>
                    <TableCell><Skeleton width="100%" /></TableCell>
                    <TableCell><Skeleton width="100%" /></TableCell>
                    <TableCell>
                        <Button
                            disabled variant="contained"
                            fullWidth disableElevation sx={{ py: 1.5 }}>خرید</Button>
                    </TableCell>
                </TableRow>
            ))}
        </TableBody>
    )
}
